import BiomarkerPanelSummaryCard from '@oncolens/oncolens-ui/lib/components/BiomarkerResults/BiomarkerPanelSummaryCard/BiomarkerPanelSummaryCard';
import Combobox, {
  ComboboxItem
} from '@oncolens/oncolens-ui/lib/components/FormControls/Combobox/Combobox';
import clsx from 'clsx';
import { useCallback, useEffect } from 'react';
import { usePostCaseConfigs } from '../hooks/PostCaseUtilities';
import AddBiomarkerPanelButton from './AddBiomarkerPanelButton';
import BiomarkerPanel from './BiomarkerPanel';
import LabMatchDrawer from './LabMatchDrawer';
import { useBiomarkerContext } from './PatientBiomarkerForm';
import { formatReportDataForSelectItem } from './BiomarkerPanelSelector.helpers';

export default function BiomarkerPanelSelector() {
  const {
    activeIds: { biomarkerId, selectedPanelId, isEditingPanel },
    biomarkerPanels,
    setActiveIds
  } = useBiomarkerContext();
  const configs = usePostCaseConfigs(['cancer']);
  const panels = formatReportDataForSelectItem(biomarkerPanels);

  const selected = panels.find((item) => item.value === selectedPanelId) || null;
  const setSelected = useCallback(
    (val: string | null) => {
      setActiveIds(() => ({
        isEditingPanel: false,
        biomarkerId: null,
        selectedPanelId: val
      }));
    },
    [setActiveIds]
  );

  useEffect(() => {
    if (!selectedPanelId && panels.length > 0) {
      setSelected(panels[0].value || null);
    }
  }, [setSelected, panels, selectedPanelId]);

  const selectedItem = biomarkerPanels.find(
    (item) => item.panel?.id === selectedPanelId || item.panelOrder?.id === selectedPanelId
  );
  const isEditing = isEditingPanel || !!biomarkerId;

  return (
    <div className="flex flex-col space-y-2">
      <div className="grid grid-cols-4 mb-2 space-x-2">
        <div className={clsx('flex col-span-4', isEditing && 'hidden')}>
          <div className="flex-grow max-w-[60%]">
            {panels.length ? (
              <Combobox
                id="combobox-panel"
                htmlName="combobox-panel"
                label="Existing biomarker results for this patient"
                value={selected as ComboboxItem}
                data={panels}
                onChange={(value: any) => setSelected(value?.value || null)}
                skipSort
              />
            ) : (
              <span className="font-light">No existing biomarker results for this patient</span>
            )}
          </div>
          <LabMatchDrawer />
        </div>
      </div>
      {selectedItem && (
        <>
          {selectedItem.panelOrder && (
            <BiomarkerPanelSummaryCard cancerConfigs={configs?.cancer} data={selectedItem} />
          )}
          {selectedItem.panel && <BiomarkerPanel data={selectedItem.panel} />}
        </>
      )}
      <AddBiomarkerPanelButton />
    </div>
  );
}
